<div class="w-full h-full bg-white m-auto" style="max-width: 500px">
  <h2 class="p-7 pt-4">
    {{ 'paymentTrackingStatus:title' | translate }}
  </h2>

  <div class="tracking-list">
    <!-- status 1 OPEN -->
    <div
      class="tracking-item"
      [class.complete]="status > 1"
      [class.current]="status == 1">
      <div class="tracking-icon -mt-1">
        <i class="fa-light fa-file-invoice-dollar"></i>
      </div>
      <div class="point"></div>
      <div class="px-3 pt-2">
        <span class="badge" [class]="'OPEN' | paymentStatusBadge">
          {{ 'transactions:status' + 'OPEN' | translate }}
        </span>
        <div class="text-gray-400 my-2">
          <span *ngIf="activities.OPEN">
            {{ activities.OPEN.modifiedAt | date : 'medium' }}
          </span>
          {{ 'corporateTrackingStatus:statusOpenTitle' | translate }}
          <span *ngIf="activities.OPEN?.modifiedBy">
            {{ activities.OPEN?.modifiedBy }}
          </span>
        </div>
        <div class="absolute bottom-0">
          {{ 'corporateTrackingStatus:statusOpenSubtitle' | translate }}
        </div>
      </div>
    </div>

    <!-- status 2 PENDING_AUTHORIZATION -->
    <div
      class="tracking-item"
      [class.complete]="status > 2"
      [class.current]="status == 2"
      *ngIf="
        corporateTrackingStatusData.status != 'OPEN' &&
        corporateTrackingStatusData.paymentMethod == 0 &&
        corporateTrackingStatusData.proofOfPayment
      ">
      <div class="tracking-icon">
        <i class="fa-light fa-triangle-exclamation"></i>
      </div>
      <div class="point"></div>
      <div class="px-3 pt-2.5">
        <span
          class="badge"
          [class]="'PENDING_AUTHORIZATION' | paymentStatusBadge">
          {{ 'transactions:status' + 'PENDING_AUTHORIZATION' | translate }}
        </span>
        <div class="text-gray-400 my-2">
          <span *ngIf="activities.PENDING_AUTHORIZATION">
            {{ activities.PENDING_AUTHORIZATION.modifiedAt | date : 'medium' }}
          </span>
          {{
            'corporateTrackingStatus:statusPendingAuthorizationTitle'
              | translate
          }}
          <span *ngIf="activities.PENDING_AUTHORIZATION?.modifiedBy">
            {{ activities.PENDING_AUTHORIZATION?.modifiedBy }}
          </span>
        </div>
        <div class="absolute bottom-0">
          {{
            'corporateTrackingStatus:statusPendingAuthorizationSubtitle'
              | translate
          }}
        </div>
      </div>
    </div>

    <!-- status 3 AUTHORIZED -->
    <!-- <div
      class="tracking-item"
      [class.complete]="status > 3"
      [class.current]="status == 3"
      *ngIf="
        corporateTrackingStatusData.status != 'OPEN' &&
        corporateTrackingStatusData.paymentMethod != 0
      ">
      <div class="tracking-icon">
        <i class="fa-light fa-triangle-exclamation"></i>
      </div>
      <div class="point"></div>
      <div class="px-3 pt-2.5">
        <span class="badge" [class]="'AUTHORIZED' | paymentStatusBadge">
          {{ 'transactions:status' + 'AUTHORIZED' | translate }}
        </span>
        <div class="text-gray-400 my-2">
          <span *ngIf="activities.AUTHORIZED">
            {{ activities.AUTHORIZED.modifiedAt | date: 'medium' }}
          </span>
          {{ 'paymentTrackingStatus:statusAuthorizedTitle' | translate }}
          <span *ngIf="activities.AUTHORIZED?.modifiedBy">
            {{ 'shared:by' | translate }}
            {{ activities.AUTHORIZED?.modifiedBy }}
          </span>
        </div>
        <div class="info absolute bottom-0">
          {{ 'paymentTrackingStatus:statusAuthorizedSubtitle' | translate }}
        </div>
      </div>
    </div> -->

    <!-- status 4 IN_TRANSIT -->
    <div
      class="tracking-item"
      [class.complete]="status > 4"
      [class.current]="status == 4"
      *ngIf="corporateTrackingStatusData.status != 'OPEN'">
      <div class="tracking-icon">
        <i class="fa-regular fa-lock"></i>
      </div>
      <div class="point"></div>
      <div class="px-3 pt-2.5">
        <span class="badge" [class]="'IN_TRANSIT' | paymentStatusBadge">
          {{ 'transactions:status' + 'IN_TRANSIT' | translate }}
        </span>
        <div class="text-gray-400 my-2">
          <span *ngIf="activities.IN_TRANSIT">
            {{ activities.IN_TRANSIT.modifiedAt | date : 'medium' }}
          </span>
          {{ 'paymentTrackingStatus:statusInTransitTitle' | translate }}
        </div>
        <div class="absolute bottom-0">
          {{ 'corporateTrackingStatus:statusInTransitSubtitle' | translate }}
        </div>
      </div>
    </div>

    <!-- status 5 RECEIVED -->
    <!-- <div
      class="tracking-item"
      [class.complete]="status > 5"
      [class.current]="status == 5"
      *ngIf="corporateTrackingStatusData.status != 'OPEN' && activities.RECEIVED">
      <div class="tracking-icon">
        <i class="fa-regular fa-building-columns"></i>
      </div>
      <div class="point"></div>
      <div class="px-3 pt-2.5">
        <span class="badge" [class]="'RECEIVED' | paymentStatusBadge">
          {{ 'transactions:status' + 'RECEIVED' | translate }}
        </span>
        <div class="text-gray-400 my-2">
          <span *ngIf="activities.RECEIVED">
            {{ activities.RECEIVED.modifiedAt | date: 'medium' }}
          </span>
          {{ 'paymentTrackingStatus:statusReceivedTitle' | translate }}
          <span *ngIf="activities.RECEIVED?.modifiedBy">
            {{ 'shared:by' | translate }}
            {{ activities.RECEIVED.modifiedBy }}
          </span>
        </div>
        <div class="info absolute bottom-0">
          {{ 'paymentTrackingStatus:statusReceivedSubtitle' | translate }}
        </div>
      </div>
    </div> -->

    <!-- status 6 CREDITED -->
    <div
      class="tracking-item"
      [class.complete]="status == 6"
      *ngIf="corporateTrackingStatusData.status !== 'OPEN'">
      <div class="border-aux end"></div>
      <div class="tracking-icon">
        <i class="fa-light fa-file-invoice-dollar"></i>
      </div>
      <div class="px-3 pt-2.5">
        <span class="badge" [class]="'CREDITED' | paymentStatusBadge">
          {{ 'transactions:status' + 'CREDITED' | translate }}
        </span>
        <div class="text-gray-400 my-2">
          <span *ngIf="activities.CREDITED">
            {{ activities.CREDITED.modifiedAt | date : 'medium' }}
          </span>
          {{ 'corporateTrackingStatus:statusCreditedSubtitle' | translate }}
        </div>
      </div>
    </div>
  </div>
</div>
